/**
 *
 * Modal
 * This modal supports any amount of children. Last child within props.children
 * will always be added to the bottom section alocated for the  action buttons.
 * The buttons should change the modal's `open` property on their click event
 * to false to close it that way. Pressing Esc key will also close the modal.
 *
 */

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Loader from 'components/Loader';
import PropTypes from 'prop-types';
import React, { Children } from 'react';
import { Typography } from 'theme';
import { DialogContentText, Title } from './styles';

/**
 * ModalConfiguration
 * @param {string} title Title to show
 * @param {function} onClose Event to execute when close modal, click outside or press esc
 * @param {boolean} open Define if this is open
 * @param {node} children supports any amount of children. Last child within props.children
 * will always be added to the bottom
 * @param {Object} paperPropsStyle Add any style to the dialog
 */

function ModalComponent(props) {
  const { onClose, open, title, children, paperPropsStyle, showLoading } = props;

  const modalContent = Children.toArray(children);
  const childrenAmount = modalContent.length - 1;

  return (
    <div>
      <Dialog
        disablebackdropclick="true"
        onClose={onClose}
        open={open}
        PaperProps={{
          // NOTE: We add this styles in here because we want to target only the
          // paper element that it's created when the modal is rendered, so it
          // doesn't affect other components that might use the Paper element
          style: {
            borderRadius: 0,
            maxHeight: 'calc(100% - 6.4rem)',
            boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.06)',
            ...paperPropsStyle,
            fontFamily: `${Typography.fontFamily} !important`,
          },
        }}
      >
        <Loader open={showLoading} />
        <Title>{title}</Title>
        <DialogContent>
          <DialogContentText>{modalContent.slice(0, childrenAmount)}</DialogContentText>
        </DialogContent>
        <DialogActions>{modalContent[`${childrenAmount}`]}</DialogActions>
      </Dialog>
    </div>
  );
}

ModalComponent.propTypes = {
  title: PropTypes.node,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  children: PropTypes.node.isRequired,
  paperPropsStyle: PropTypes.object,
  showLoading: PropTypes.bool,
};

export default ModalComponent;
